import React from 'react'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { useIntegrationDocsURL } from '../../../../../../utils/docs'
import SimphonyApi from './SimphonyApi'
import DimensionMap from '../dimensionMap/DimensionMap'

const Simphony: React.FC = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()

  const items = [
    { label: t('integrationsPage:api'), key: 'api', children: <SimphonyApi /> },
    {
      label: t('integrationsPage:restaurants'),
      key: 'restaurants',
      children: (
        <DimensionMap
          getDimensionsUrl="/simphony/locations/{companyId}"
          updateDimensionsUrl="/simphony/locations/{companyId}/{id}"
          dataKey="locRef"
        />
      )
    }
  ]

  return (
    <>
      <a href={integrationDocs.external('simphony')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <Tabs items={items} destroyOnHidden />
    </>
  )
}

export default Simphony
